import { george, i18n, observer, pr, React, theme, ui } from "aaa";
import externalInterfaceStore from "stores/ExternalInterfaceStore";

const DIV_16_CONTENT = ({ children }: { children: React.ReactNode }) => <div className="theme-paragraph-color">{children}</div>;

type IBaseProps = {
    icon: any;
    iconStyle?: React.CSSProperties;
    title?: string;
    message?: string;
    messageComponent?: any;
    buttonLabelId?: i18n.IDS;
    onDismiss: () => void;
    backgroundColor?: string;
};

type IProps = IBaseProps & {
    CustomButtonComponent?: React.ReactNode;
    useWebVersion?: false;
};

type IPropsWebVersion = IBaseProps & {
    CustomButtonComponent?: React.ReactNode;
    useWebVersion: true;
    variant: "success" | "danger" | "default";
};

@i18n.injectIntl
@observer
export class MessageScreen extends React.Component<(IProps | IPropsWebVersion) & i18n.InjectedIntlProps, {}> {
    componentDidMount() {
        window.scrollTo(0, 0);

        if (!this.props.useWebVersion || externalInterfaceStore.isGeorgeApp) {
            document.body.style.backgroundColor = this.props.backgroundColor || theme.headerBackgroundColor(ui.isDarkMode);
        }
    }

    componentWillUnmount() {
        document.body.style.backgroundColor = "";
    }

    render() {
        const iconSize = Math.min(ui.windowWidth * 0.4, theme.HEADER_ICON_SIZE);

        const showButton = !!this.props.buttonLabelId && (
            externalInterfaceStore.isGeorgeApp ||
            this.props.buttonLabelId !== "common.backToGeorgeGo"
        );

        const isGeorgeApp = externalInterfaceStore.isGeorgeApp;

        let BackgroundComponent = george.MessageScreenBackground;
        let MessageTextComponent = pr.MessageScreenText;
        let textColor: string | undefined = "white";
        let iconColor = "white";
        let marginTop = 20;
        let titleClassName;
        let bottomMargin = 100;

        const isWebVersion = this.props.useWebVersion && !isGeorgeApp;
        const showAppButton = showButton && this.props.buttonLabelId && !isWebVersion;
        const showWebButton = showButton && this.props.buttonLabelId && isWebVersion;

        if (isWebVersion) {
            BackgroundComponent = george.Card;
            MessageTextComponent = DIV_16_CONTENT;
            textColor = undefined;
            if (this.props.useWebVersion) {
                if (this.props.variant === "success") {
                    iconColor = theme.themeColors.ui_green;
                } else if (this.props.variant === "danger") {
                    iconColor = theme.themeColors.ui_red;
                } else if (this.props.variant === "default") {
                    iconColor = "black";
                }
            }

            marginTop = 50;
            titleClassName = "theme-title-color";
            bottomMargin = 50;
        }

        return (
            // Outer VFlex is because of IE, without it the justify-content: center of george.MessageScreenBackground does not work
            // See https://stackoverflow.com/a/29270539/677910
            <pr.VFlex>
                <BackgroundComponent
                    style={{
                        marginTop: isWebVersion ? theme.HEADER_CONTENT_SPACING : undefined,
                        backgroundColor: !this.props.useWebVersion || externalInterfaceStore.isGeorgeApp ? this.props.backgroundColor : undefined
                    }}
                >
                    <pr.VFlex style={{ textAlign: "center" }}>
                        <div style={{ marginTop }}>

                            {/* <pr.GeorgeIconWrapper
                                color="white"
                                size={iconSize}
                                iconName="#ico-check-circle"
                            /> */}
                            <this.props.icon style={{ width: iconSize, height: iconSize, color: iconColor, ...this.props.iconStyle }} />
                        </div>

                        {this.props.title &&
                            <pr.MessageLabelContainer>
                                <pr.H1WithFocus
                                    style={{
                                        fontSize: 24,
                                        // fontSize: Math.min(0.06 * ui.windowWidth, 28)
                                        fontWeight: 600,
                                        color: textColor,
                                    }}
                                    className={titleClassName}
                                >
                                    {this.props.title}
                                </pr.H1WithFocus>
                            </pr.MessageLabelContainer>
                        }
                        <pr.MessageLabelContainer>
                            <MessageTextComponent>
                                {this.props.message ? this.props.message : this.props.messageComponent}
                            </MessageTextComponent>
                        </pr.MessageLabelContainer>

                    </pr.VFlex>

                    {/* Filler for Button, not using padding, because it grows outer div */}
                    {(!isWebVersion || !showWebButton || this.props.CustomButtonComponent) &&
                        <div style={{ height: bottomMargin }} />
                    }

                    {!this.props.CustomButtonComponent && showAppButton && this.props.buttonLabelId &&
                        <george.SuccessButton
                            label={ui.__(this.props.buttonLabelId)}
                            onClick={this.props.onDismiss}
                        />
                    }
                    {!this.props.CustomButtonComponent && showWebButton && this.props.buttonLabelId &&
                        <>
                            <pr.LightSeparatorLine spacing={theme.MARGIN} />
                            <george.ActionButton
                                messageId={this.props.buttonLabelId}
                                onClick={this.props.onDismiss}
                                inline
                                style={{ padding: theme.MARGIN, paddingBottom: theme.MARGIN_LARGE }}
                            />
                        </>
                    }
                    {!!this.props.CustomButtonComponent && this.props.CustomButtonComponent}
                </BackgroundComponent>
            </pr.VFlex>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/common/MessageScreen.tsx